type Role = 'ADMIN' | 'MANAGER' | 'PLANNER' | 'SPECTATOR' | 'Manager' | 'Planner' | 'Spectator';

const dutchRoles: Record<Role, string> = {
  ADMIN: 'BEHEERDER',
  MANAGER: 'MANAGER',
  PLANNER: 'PLANNER',
  SPECTATOR: 'TOESCHOUWER',
  Manager: 'MANAGER',
  Planner: 'PLANNER',
  Spectator: 'TOESCHOUWER',
};

export const translateRoleToDutch = (role: Role | string): string => {
  const uppercasedRole = role.toUpperCase() as Role;
  return dutchRoles[uppercasedRole] || role;
};
